module.exports = "/_next/static/images/cd2ae78d4a4da22b48c104fc23457ef2-ticket-02-03.png.webp";